import { CONTROL_BUCKET } from './default-buckets';

const EXPERIMENT_BUCKET = 'includes-video';
const BUCKETS = [CONTROL_BUCKET, EXPERIMENT_BUCKET];
const IDENTIFIER = 'BrowserCookieId';
const NAME = 'car-stc-landing-page-video-1';

export { BUCKETS, CONTROL_BUCKET, IDENTIFIER, NAME, EXPERIMENT_BUCKET };
